import { useEffect, useState } from 'react';
import AgentSidebar from '../components/AgentSidebar';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

const STATUS_STYLES = {
  CONFIRMED: 'bg-green-100 text-green-700',
  PENDING_REVIEW: 'bg-amber-100 text-amber-700',
  REJECTED: 'bg-red-100 text-red-700',
};

export default function AgentPaymentsPage() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  const fetchPayments = () => {
    setLoading(true);
    fetch(`${API_BASE}/admin/payments`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => setPayments(json.success ? json.data : []))
      .finally(() => setLoading(false));
  };

  useEffect(fetchPayments, []);

  const handleConfirm = async (id) => {
    await fetch(`${API_BASE}/admin/payments/${id}/confirm`, { method: 'PATCH', headers: { Authorization: `Bearer ${token}` } });
    fetchPayments();
  };

  const handleReject = async (id) => {
    await fetch(`${API_BASE}/admin/payments/${id}/reject`, { method: 'PATCH', headers: { Authorization: `Bearer ${token}` } });
    fetchPayments();
  };

  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <AgentSidebar />
      <main className="pt-16 md:pt-2 md:ml-64 min-h-screen p-8">
        <h2 className="text-3xl font-bold text-[#00255a] mb-1">Payments</h2>
        <p className="text-[#64748b] mb-8">Manual payment tracking for your applications.</p>

        <div className="bg-white rounded-xl border border-[#e2e8f0] shadow-sm overflow-hidden">
          <table className="w-full text-left">
            <thead className="bg-[#f2f4f6]">
              <tr>
                {['Applicant', 'Label', 'Amount', 'Proof', 'Status', ''].map((h) => (
                  <th key={h} className="px-6 py-4 text-xs uppercase text-[#64748b]">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#e2e8f0]">
              {loading ? (
                <tr><td colSpan="6" className="p-12 text-center text-[#64748b]">Loading...</td></tr>
              ) : payments.length === 0 ? (
                <tr><td colSpan="6" className="p-12 text-center text-[#64748b]">No payments logged for your applications.</td></tr>
              ) : (
                payments.map((p) => (
                  <tr key={p.id} className="hover:bg-[#f7f9fb] transition-colors">
                    <td className="px-6 py-4 font-semibold text-[#0f172a]">{p.application?.applicant?.fullName}</td>
                    <td className="px-6 py-4 text-sm">{p.label}</td>
                    <td className="px-6 py-4 font-bold text-[#00255a]">{p.currency} {Number(p.amount).toLocaleString()}</td>
                    <td className="px-6 py-4">
                      {p.proofUrl ? (
                        <a href={p.proofUrl} target="_blank" rel="noreferrer" className="text-[#00255a] font-semibold text-sm hover:underline">View</a>
                      ) : '—'}
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${STATUS_STYLES[p.status]}`}>{p.status.replace('_', ' ')}</span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      {p.status === 'PENDING_REVIEW' && (
                        <div className="flex justify-end gap-2">
                          <button onClick={() => handleConfirm(p.id)} className="p-2 text-emerald-600 hover:bg-emerald-50 rounded-full">
                            <span className="material-symbols-outlined text-[18px]">check_circle</span>
                          </button>
                          <button onClick={() => handleReject(p.id)} className="p-2 text-red-500 hover:bg-red-50 rounded-full">
                            <span className="material-symbols-outlined text-[18px]">cancel</span>
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}